import { render, staticRenderFns } from "./TcgSdk.vue?vue&type=template&id=38c4cea2&scoped=true"
import script from "./TcgSdk.vue?vue&type=script&lang=js"
export * from "./TcgSdk.vue?vue&type=script&lang=js"
import style0 from "./TcgSdk.vue?vue&type=style&index=0&id=38c4cea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4cea2",
  null
  
)

export default component.exports